import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import CardContent from '@mui/material/CardContent';

const StyledCardContent = styled(CardContent)`
  && {
    padding: ${props => props.theme.spacing(2)};
  }

  &.CardContent-density-densest {
    padding: 0;
  }
  
  ${ComponentStyles}
`;

StyledCardContent.propTypes = {
  theme: PropTypes.object
};

export default StyledCardContent;
